import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { Router } from '@angular/router';

@Injectable()
export class EcomicService {

  constructor(private afs: AngularFirestore) { }

  async getsinglecomic(id, type) {
    try {
      const admin = await this.afs.doc(`${type}/${id}`);
      const admindata = await admin.valueChanges();
      return admindata;
    } catch (error) {
      throw error;
    }
  }
  // function to get all comic series
  async getserious() {
    try {
      const comics = await this.afs.collection(`Ecomicseries`);
      const comicsdata = await comics.valueChanges();
      return comicsdata;
    } catch (error) {
      throw error;
    }
  }
  async getWISSeasons() {
    try {
      const WIS = await this.afs.collection(`WISSeason`);
      const WISdata = await WIS.valueChanges();
      return WISdata;
    } catch (error) {
      throw error;
    }
  }
  // function to get all comic season based on the seried id
  async getseasons(id) {
    try {
      const eseasons = await this.afs.collection(`Ecomicseason`, res => {
        return res.where('comic_series', '==', id);
      });
      const eseasosdata = await eseasons.valueChanges();
      return eseasosdata;
    } catch (error) {
      throw error;
    }
  }
  async getsinglenovel(id, type) {
    try {
      const admin = await this.afs.doc(`${type}/${id}`);
      const admindata = await admin.valueChanges();
      return admindata;
    } catch (error) {
      throw error;
    }
  }
  async getnovelserious() {
    try {
      const novels = await this.afs.collection(`Enovelseries`);
      const novelsdata = await novels.valueChanges();
      return novelsdata;
    } catch (error) {
      throw error;
    }
  }
  async getnovelseasons(id) {
    try {
      const eseasons = await this.afs.collection(`Enovelseason`, res => {
        return res.where('novel_series', '==', id);
      });
      const eseasosdata = await eseasons.valueChanges();
      return eseasosdata;
    } catch (error) {
      throw error;
    }
  }
  async checkchapter(season, chapter) {
    return new Promise(async (resolve) => {
      const checkchapter = await this.afs.collection('Enovelchapter', res => {
        return res.where('novel_seasons', '==', season )
        .where('chapter_no','==',chapter)
    }).valueChanges()
    const check = await checkchapter.subscribe(available => {
      console.log(available);
      
      if (available.length>=1){
        resolve(true)
      } else {
        resolve(false)
      }
    })
  })
  }
  async checkWISEpisode(season, chapter) {
    return new Promise(async (resolve) => {
      const checkchapter = await this.afs.collection('WISEpisodes', res => {
        return res.where('season_id', '==', season )
        .where('chapter_no','==',chapter)
    }).valueChanges()
    const check = await checkchapter.subscribe(available => {
      console.log(available);
      
      if (available.length>=1){
        resolve(true)
      } else {
        resolve(false)
      }
    })
  })
  }
  async checkepisode(season, episode) {
    return new Promise(async (resolve) => {
      const checkepisode = await this.afs.collection('Ecomicepisode', res => {
        return res.where('comic_seasons', '==', season )
        .where('episode_no','==',episode)
    }).valueChanges()
    const check = await checkepisode.subscribe(available => {
      console.log(available);
      
      if (available.length>=1){
        resolve(true)
      } else {
        resolve(false)
      }
    })
  })
  }
  async deleteseries(colname,key, value){
    // colname => db collection name
    return new Promise(async (resolve) => {
      const checkseries = await this.afs.collection(colname, res => {
        return res.where(key, '==', value )
    }).valueChanges()
    const check = await checkseries.subscribe(available => {
      if (available.length>=1){
        resolve(false)
      } else {
        resolve(true)
      }
    })
  })
  }
 
}



// WEBPACK FOOTER //
// ./src/app/service/comics/ecomic.service.ts